<template>
    <div>
            <el-row>
                <el-col :span="12">客户名称:<span>{{item.vip_custom_name}}</span></el-col>
                <el-col :span="12">联系电话:<span>{{item.vip_custom_phone}}</span></el-col>
                <el-col :span="12">地区:<span>{{item.province_name}}{{item.city_name}}{{item.area_name}}</span></el-col>
                <el-col :span="12">详细地址:<span>{{item.address}}</span></el-col>
                <el-col :span="12">创建时间:<span>{{item.create_date}}</span></el-col>
            </el-row>
    </div>
</template>

<script>
export default {
  name: "custom_info",
  props:['item'],

}
</script>

<style scoped>
.el-col{
    color: #18181c;
    font-size: 12px;
    line-height: 22px;
    font-weight: 500px;
}
    .el-col>span{
        color: #18181c;
        font-size: 12px;
        font-weight: 400px;
        padding-left: 10px;
    }
</style>
